import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/bestdentistsurat.com/src/components/pages/blog-detail/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/bestdentistsurat.com/src/components/pages/categories/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/bestdentistsurat.com/src/components/pages/home/index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/data/bestdentistsurat.com/src/components/pages/product-detail/index.jsx");
